import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { FilterTable } from 'gnos-tables'
import _ from 'lodash'

import CellStyleWrapper from '../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'
import CustomDate from '../../../../../../../../../../../components/CustomDate'
import Entity from '../../../../../../../../../../../components/TableCell/components/Entity'
import Flag from '../../../../../../../../../../../components/TableCell/components/Flag'
import InactiveIndicatorCell from '../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Cell'
import InactivityIndicatorHeader from '../../../../../../../../../../../components/TableCell/components/InactiveIndicator/Header'
import NoData from '../../../../../../../../../components/Workspace/components/NoData'
import Signals from '../../../../../../../../../../../components/TableCell/components/Signals'

import { LOCALE_PREFIX } from '../../constants'

import PersonTrades from './components/PersonTrades'

import hocConnect from './hocConnect'
import './style.scss'

@injectIntl
@hocConnect
export default class Representatives extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        data: PropTypes.array,
        filter: PropTypes.object,
        locked: PropTypes.bool,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        isLoading: PropTypes.bool,
        level: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        pagination: PropTypes.object,
        personsRepresentativesTableChange: PropTypes.func.isRequired,
        sorted: PropTypes.array,
    }

    getColumnsDefinition = () => {
        const { filter, intl } = this.props

        return [
            {
                id: 'activity',
                accessor: 'inactive',
                Header: ({ Controls }) => (
                    <div>
                        {Controls}
                        <InactivityIndicatorHeader />
                    </div>
                ),
                Cell: ({ value }) => <InactiveIndicatorCell inactive={value} />,
                width: 35,
                filterable: true,
                filter: {
                    type: 'VALUE',
                    value: _.map(_.get(filter, 'availableParameters.activity.availableValues', []), (x) => ({
                        value: _.get(x, 'value', null),
                        item: _.get(x, 'title', null),
                    })),
                },
            },
            {
                accessor: 'subject',
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.subject` }),
                Cell: ({ value, original }) => (
                    <div className={'persons-table-entity-cell'}>
                        <CellStyleWrapper isCentered>
                            {value?.countryIso !== 'CZ' && !_.isNil(value?.countryIso) && (
                                <Flag country={_.lowerCase(value?.countryIso)} />
                            )}
                            <Entity
                                entity={value}
                                entId={value?.id}
                                inactive={value?.inactive}
                                type={value?.type}
                                value={value?.name}
                                rowInactive={original?.inactive}
                            />
                        </CellStyleWrapper>
                    </div>
                ),
            },
            {
                id: 'indicators',
                accessor: 'subject',
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.indicators` }),
                Cell: ({ value, original }) => (
                    <CellStyleWrapper isNotActive={original?.inactive}>
                        <Signals
                            id={value?.id}
                            caution={value?.indicators?.caution}
                            risk={value?.indicators?.risk}
                            notice={value?.indicators?.notice}
                        />
                    </CellStyleWrapper>
                ),
                width: 200,
            },
            {
                id: 'startDate',
                accessor: 'dateRange',
                sortable: true,
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.dateFrom` }),
                Cell: ({ value, original }) => (
                    <CellStyleWrapper isNotActive={original?.inactive}>
                        <CustomDate date={value?.startDate?.value} precision={value?.startDate?.precision} />
                    </CellStyleWrapper>
                ),
                width: 100,
            },
            {
                id: 'endDate',
                accessor: 'dateRange',
                sortable: true,
                Header: intl.formatMessage({ id: `${LOCALE_PREFIX}.dateTo` }),
                Cell: ({ value, original }) => (
                    <CellStyleWrapper isNotActive={original?.inactive}>
                        <CustomDate date={value?.endDate?.value} precision={value?.endDate?.precision} />
                    </CellStyleWrapper>
                ),
                width: 100,
            },
        ]
    }

    onTableChange = (tableChange) => {
        const { module, block, id, level, personsRepresentativesTableChange } = this.props

        personsRepresentativesTableChange(module, block, id, level, tableChange)
        return null
    }

    renderSubComponent = (rowData) => {
        const { id } = this.props

        return <PersonTrades id={id} data={rowData?.row?.original?.trades ?? []} />
    }

    render() {
        const { id, intl, data, pagination, sorted, filter, isLoading, locked } = this.props

        if (locked) {
            return (
                <div className={'persons-representatives-block'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.lockedTab` })} />
                </div>
            )
        }

        if (_.isEmpty(data) && _.isEmpty(filter?.activeFilters)) {
            return (
                <div className={'persons-representatives-block'}>
                    <NoData text={intl.formatMessage({ id: `${LOCALE_PREFIX}.noData` })} />
                </div>
            )
        }

        return (
            <div className={'persons-representatives-block'}>
                <FilterTable
                    id={`persons-representatives-table-${id}`}
                    itemIdentifier={'subject.id'}
                    columnsDefinition={this.getColumnsDefinition()}
                    data={data ?? []}
                    onTableChange={this.onTableChange}
                    loading={isLoading}
                    settings={{
                        pagination,
                        sorted,
                        filtered: (filter?.activeFilters ?? []).map((actFilter) => ({
                            id: actFilter?.id,
                            value: actFilter?.value || [],
                        })),
                    }}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    texts={{
                        pagination: {
                            page: intl.formatMessage({ id: 'global.page' }),
                            from: intl.formatMessage({ id: 'global.of' }),
                            rowCount: intl.formatMessage({ id: 'global.rowCount' }),
                            rowShow: intl.formatMessage({ id: 'global.rowShow' }),
                            all: intl.formatMessage({ id: 'global.all' }),
                        },
                        filter: {
                            valueTitle: intl.formatMessage({ id: 'global.valueTitle' }),
                            fulltextTitle: intl.formatMessage({ id: 'global.fulltextTitle' }),
                        },
                    }}
                    SubComponent={(rowData) => this.renderSubComponent(rowData)}
                    expandOnRowClick
                />
            </div>
        )
    }
}
